<template>
  <!-- Formulario -->
  <v-form ref="form" autocomplete="off">
    <v-row>
      <!-- Usuario -->
      <v-col cols="12" sm="4" md="6">
        <v-autocomplete
          v-model="editedItem.Usuario"
          :items="ArrayUser"
          :item-title="
            (ArrayUser) =>
              ArrayUser.Usuario + '-' + ArrayUser.Nombre + ' ' + ArrayUser.Apellido
          "
          item-value="Usuario"
          label="Usuario:"
          dense
          :rules="[rules.required]"
          readonly
        >
        </v-autocomplete>
      </v-col>

      <!-- Roles -->
      <v-col cols="12" sm="6" md="6">
        <v-autocomplete
          v-model="editedItem.Perfil_ID"
          :items="ArrayRoles"
          :item-title="(ArrayRoles) => ArrayRoles.Id + '-' + ArrayRoles.NombrePerfil"
          item-value="Id"
          color="primary"
          label="Roles: "
          dense
          hint="Digite Información"
          :rules="[rules.required]"
          :clearable="this.editedIndex != -1 ? false : true"
          :readonly="this.editedIndex != -1 ? true : false"
        >
        </v-autocomplete>
      </v-col>

      <!-- Area -->
      <v-col cols="12" sm="6" md="6">
        <v-autocomplete
          v-model="editedItem.Area"
          :items="ArrayArea"
          :item-title="(ArrayArea) => ArrayArea.AreaId + '-' + ArrayArea.Descripcion"
          item-value="AreaId"
          color="primary"
          label="Area:"
          dense
          hint="Digite Información"
          clearable
        >
        </v-autocomplete>
      </v-col>

      <!-- Cargo -->
      <v-col cols="12" sm="6" md="6">
        <v-autocomplete
          v-model="editedItem.Cargo"
          :items="ArrayCargo"
          :item-title="(ArrayCargo) => ArrayCargo.CargoId + '-' + ArrayCargo.Descripcion"
          item-value="CargoId"
          color="primary"
          label="Cargo:"
          dense
          hint="Digite Información"
          clearable
        >
        </v-autocomplete>
      </v-col>

      <!-- Acceso a Procesos -->
      <v-col cols="12" sm="6" md="6">
        <v-autocomplete
          v-model="editedItem.AccesoProcesos"
          :items="ArrayEstado"
          :item-title="(ArrayEstado) => ArrayEstado.Valor + '-' + ArrayEstado.Descripcion"
          item-value="Valor"
          label="Acceso a procesos:"
          dense
          :rules="[rules.required]"
          clearable
        >
        </v-autocomplete>
      </v-col>

      <!-- Acceso a Acceso Informacion Procesos -->
      <v-col cols="12" sm="6" md="6">
        <v-autocomplete
          v-model="editedItem.AccesoInformacionProcesos"
          :items="ArrayEstado"
          :item-title="(ArrayEstado) => ArrayEstado.Valor + '-' + ArrayEstado.Descripcion"
          item-value="Valor"
          label="Acceso a información de procesos:"
          dense
          :rules="[rules.required]"
          clearable
        >
        </v-autocomplete>
      </v-col>

      <!-- Calendario -->
      <v-col cols="12" sm="6" md="6">
        <v-autocomplete
          v-model="editedItem.Calendario"
          :items="ArrayCalendar"
          :item-title="
            (ArrayCalendar) =>
              ArrayCalendar.CalendarioId + '-' + ArrayCalendar.Descripcion
          "
          item-value="CalendarioId"
          color="primary"
          label="ID Calendario Atención:"
          :rules="[(v) => !!v || 'Campo obligatorio']"
          dense
          clearable
        >
        </v-autocomplete>
      </v-col>

      <!-- Estado -->
      <v-col cols="12" sm="2" md="2">
        <v-switch
          v-model="editedItem.Estado"
          color="red-darken-3"
          label="Estado"
          hide-details
          inset
        ></v-switch>
      </v-col>
    </v-row>
    <!--////////////////////////////////////////////// Auditoria ////////////////////////////////////////////////////////////-->
    <br />
    <v-row>
      <v-col v-if="editedIndex != -1" cols="12" sm="12" md="6">
        <span>Usuario Creación: {{ editedItem.UsuarioCreacion }}</span>
      </v-col>
      <v-col v-if="editedIndex != -1" cols="12" sm="12" md="6">
        <span>Usuario Actualización: {{ editedItem.UsuarioActualizacion }}</span>
      </v-col>
      <v-col v-if="editedIndex != -1" cols="12" sm="12" md="6">
        <span>Fecha Creación: {{ editedItem.FechaCreacion }}</span>
      </v-col>
      <v-col v-if="editedIndex != -1" cols="12" sm="12" md="6">
        <span>Fecha Actualización: {{ editedItem.FechaActualizacion }}</span>
      </v-col>
    </v-row>
    <div align="right">
      <br />
      <v-btn size="x-large" v-if="!buttonSave" color="green" text @click="ValidateCampos">
        Guardar
      </v-btn>
    </div>
  </v-form>

  <!-- Linea de progreso -->
  <div class="d-flex align-center flex-column">
    <v-dialog v-model="progreso" persistent width="auto">
      <v-card color="red-darken-4">
        <v-card-text>
          Espera un momento...
          <v-toolbar align="center" color="red-darken-4">
            <v-img class="mx-auto" :width="5" src="/static/iconos/logo2.png"></v-img>
          </v-toolbar>
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import {
  putUpdate,
  postInsert,
} from "@/views/TCI/Seguridad/RelacionUsuarioPerfil/RelacionUsuarioPerfilService";
import { TablaSeleccion } from "@/views/TCI/Seguridad/Constantes/ConstantesSeguridad";

export default {
  name: "rup-registro",
  props: {
    editedIndex: {
      type: Number,
      default: 0,
      Description: "Cambia de actualización a creación o visceversa",
    },
    infoedit: {
      type: Object,
      default: [],
      Description: "Información de datos",
    },
    page: {
      type: Boolean,
      default: false,
      Description: "Saber desde donde se llama la página",
    },
    pageiframe: {
      type: Boolean,
      default: false,
      Description: "LLamado a Página Iframe",
    },
    componenteview: {
      type: Number,
      default: 0,
      Description: "Saber a que página llamar",
    },
    iconodialogbtn: {
      type: String,
      default: null,
      Description: "Información icono iframe",
    },
    titledialogbtn: {
      type: String,
      default: null,
      Description: "Información titulo iframe",
    },
    Exito: {
      type: String,
      default: null,
      Description: "Información de respuesta post o put",
    },
    userId: {
      type: String,
      default: null,
      Description: "Información de respuesta post o put",
    },
  },
  data() {
    return {
      progreso: false,
      componenteview: 0,
      buttonSave: false,
      editedItem: {
        Usuario: this.userId,
        Perfil_ID: null,
        Area: null,
        Cargo: null,
        AccesoProcesos: null,
        AccesoInformacionProcesos: null,
        Calendario: null,
        Estado: true,
        UsuarioCreacion: null,
        FechaCreacion: null,
        UsuarioActualizacion: null,
        FechaActualizacion: null,
      },
      defaultItem: {
        Usuario: this.userId,
        Perfil_ID: null,
        Area: null,
        Cargo: null,
        AccesoProcesos: null,
        AccesoInformacionProcesos: null,
        Calendario: null,
        Estado: true,
        UsuarioCreacion: null,
        FechaCreacion: null,
        UsuarioActualizacion: null,
        FechaActualizacion: null,
      },
      ArrayUser: [],
      ArrayRoles: [],
      ArraArea: [],
      ArrayCargo: [],
      ArrayEstado: [],
      ArrayCalendar: [],
      rules: {
        required: (v) => !!v || "Campo obligatorio",

        email: (v) =>
          !v || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) || "Correo electrónico inválido",
      },
    };
  },

  methods: {
    // Convertir a numero
    isNumber: function (evt) {
      evt = evt || window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    ///////////////////////////////////////////////// Métodos de consulta ///////////////////////////////////////////
    // Validación de campos
    async ValidateCampos() {
      const { valid } = await this.$refs.form.validate();
      if (!valid) {
        this.$swal({
          icon: "warning",
          title: "Campos Incompletos.",
          html: " Hay campos que se encuentran incompletos.",
        });
        this.$refs.form.validate();
        return;
      }

      // Consultas a Ejecutar
      var userperfil = this.$store.getters.userperfil;
      this.editedItem.UsuarioActualizacion = userperfil.userInfo.Usuario_ID;
      this.editedItem.UsuarioCreacion = userperfil.userInfo.Usuario_ID;

      if (this.editedIndex != -1) {
        this.putRegistro();
      } else {
        this.postRegistro();
      }
    },

    // Crear Registro
    async postRegistro() {
      this.progreso = true;
      try {
        const result = await postInsert(this.editedItem);
        this.reset();
        var data = false;
        this.$emit("update:page", data);
        this.$emit("update:Exito", result);
        this.$swal({
          icon: "success",
          title: "¡Éxito!",
          html: " El registro fue guardado correctamente.",
        });
      } catch (error) {
        console.error(error);
        const registro = error.data || {};
        const mensajeerror =
          registro.Mensaje || registro.ExceptionMessage || JSON.stringify(registro);

        if (error.status === 404) {
          this.$swal({
            icon: "warning",
            title: "Consulta inexistente.",
            html: mensajeerror,
          });
        } else {
          this.$swal({
            icon: "error",
            title: "Error al consultar",
            html:
              "El servidor ha encontrado la siguiente condición inesperada:<br><small><code>" +
              mensajeerror +
              "</code></small>",
          });
        }
      } finally {
        this.progreso = false;
      }
    },

    // Actualizacion de registro
    async putRegistro() {
      this.progreso = true;
      try {
        const result = await putUpdate(this.editedItem);
        this.reset();
        var data = false;
        this.$emit("update:page", data);
        this.$emit("update:Exito", result);
        this.$swal({
          icon: "success",
          title: "¡Éxito!",
          html: " El registro fue guardado correctamente.",
        });
      } catch (error) {
        console.error(error);
        const registro = error.data || {};
        const mensajeerror =
          registro.Mensaje || registro.ExceptionMessage || JSON.stringify(registro);

        if (error.status === 404) {
          this.$swal({
            icon: "warning",
            title: "Consulta inexistente.",
            html: mensajeerror,
          });
        } else {
          this.$swal({
            icon: "error",
            title: "Error al consultar",
            html:
              "El servidor ha encontrado la siguiente condición inesperada:<br><small><code>" +
              mensajeerror +
              "</code></small>",
          });
        }
      } finally {
        this.progreso = false;
      }
    },

    ///////////////////////////////////////////////// Métodos de acciones ///////////////////////////////////////////
    reset() {
      this.editedItem = Object.assign({}, this.defaultItem);
    },

    // Cargue Combos
    CargueCombos() {
      var Tables = this.$store.getters.MTablaSeleccion;

      var User = this.$store.getters.MUsers;
      this.ArrayUser = User;

      var Perfil = this.$store.getters.MRol;
      this.ArrayRoles = Perfil;

      var Area = this.$store.getters.MArea;
      this.ArrayArea = Area;

      var Cargo = this.$store.getters.MCargo;
      this.ArrayCargo = Cargo;

      var Calendario = this.$store.getters.MCalendario;
      this.ArrayCalendar = Calendario.filter((item) => item.Calendario_ID != 0);

      this.ArrayEstado = Tables.filter(
        (item) =>
          item.Valor != null && item.TablaId == TablaSeleccion.EstadoActivoInactivo
      );
    },

    // Actualizar carga
    ActualizarCargue() {
      if (this.editedIndex != -1) {
        // Actualizar
        this.editedItem = this.infoedit;
      }
    },
  },
  mounted() {
    this.CargueCombos();
    this.ActualizarCargue();
  },
};
</script>
